var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5492",
    "data-name": "Rectangle 5492",
    width: 20,
    height: 18,
    fill: "none",
    stroke: "#fc3",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35446",
    "data-name": "Group 35446",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35445",
    "data-name": "Group 35445",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39478",
    "data-name": "Path 39478",
    d: "M3.333,6.667l5-6,5,6",
    transform: "translate(1.667 0.333)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39479",
    "data-name": "Path 39479",
    d: "M18.667,4.667l-2,8a2.657,2.657,0,0,1-.711,1.454,1.765,1.765,0,0,1-1.29.547h-10a1.765,1.765,0,0,1-1.29-.547,2.657,2.657,0,0,1-.711-1.454l-2-8Z",
    transform: "translate(0.333 2.333)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/shop-icon.86f6eefab02c86f393ac3cede6417543.svg";
export { ForwardRef as ReactComponent };